var _ = require("underscore");
var cio_datamodel = require("cio-datamodel");
var toSVGutil = require("./toSVGutil");

var drawRectangleDataTo2D = function (svg, group, data, attrs) {
    console.assert(data instanceof cio_datamodel.RectangleData);
    var attrs_total = {
    	rx: data.rx(),
    	ry: data.ry(),
        transform: toSVGutil.rotateTransform(data),
    };
    _.extend(attrs_total, toSVGutil.styleToAttributes(data));
    if(attrs) _.extend(attrs_total, attrs);

    return svg.rect(group,
        data.lowerLeftPos().getX(),
        data.lowerLeftPos().getY(),
        data.width(),
        data.height(),
        attrs_total);
};

module.exports = drawRectangleDataTo2D;

// RectDataFromSVG = function (svg) {
//     var svgObject = $(svg);
//     if (svgObject.length == 0)
//         return;

//     this.width(parseFloat(svgObject.attr('width')));
//     this.height(parseFloat(svgObject.attr('height')));
//     this.center(new lib_geometry.Coord(parseFloat(svgObject.attr('x') ? svgObject.attr('x') : 0) + this.width() / 2, parseFloat(svgObject.attr('y') ? svgObject.attr('y') : 0) + this.height() / 2));

//     if (svgObject.attr('rx')) this.rx(parseFloat(svgObject.attr('rx')));
//     if (svgObject.attr('ry')) this.ry(parseFloat(svgObject.attr('ry')));
//     if (svgObject.attr('transform')) this.angle(parseFloat(svgObject.attr('transform').match(/[\-]?[0-9.]+/g)[0]));

//     SvgHelpers.getSvgStyleProperties(this, svgObject);
// };

